module.exports = __webpack_public_path__ + "static/media/shot_200831_115718.61e359a0.png";